import { Header } from "@/components/Header";
import { HeroSection } from "@/components/HeroSection";
import { Benefits } from "@/components/Benefits";
import { HowItWorks } from "@/components/HowItWorks";
import { Pricing } from "@/components/Pricing";
import { FinalCTA } from "@/components/FinalCTA";
import { Footer } from "@/components/Footer";

const Index = () => (
  <div className="min-h-screen bg-background">
    <Header />
    <main>
      <HeroSection />
      <Benefits />
      <HowItWorks />
      <Pricing />
      <FinalCTA />
    </main>
    <Footer />
  </div>
);

export default Index;
